"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _H = _interopRequireDefault(require("../elements/headings/H2"));

var _H2 = _interopRequireDefault(require("../elements/headings/H4"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIForm = _interopRequireDefault(require("../form/UIForm"));

var _UIFormControl = _interopRequireDefault(require("../form/UIFormControl"));

var _UIModalDialog = _interopRequireDefault(require("./UIModalDialog"));

var _UIDialogBody = _interopRequireDefault(require("./UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("./UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("./UIDialogHeader"));

var _UIMatchTextArea = _interopRequireDefault(require("../input/UIMatchTextArea"));

var _PromptablePropInterface = _interopRequireDefault(require("../decorators/PromptablePropInterface"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var CONFIRM = 'confirm';
var REJECT = 'reject';

var canSubmit = function canSubmit(confirmButtonProps, disableConfirm, match, isMatched) {
  if (confirmButtonProps && confirmButtonProps.disabled) return false;
  if (typeof disableConfirm === 'boolean') return !disableConfirm;
  if (match) return isMatched;
  return true;
};

var UIConfirmDialog = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIConfirmDialog, _PureComponent);

  function UIConfirmDialog() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIConfirmDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIConfirmDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isMatched: false
    };

    _this.handleMatchedChange = function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        isMatched: value
      });
    };

    _this.handleConfirm = function () {
      _this.props.onConfirm(true);
    };

    _this.handleConfirmClick = function (evt) {
      evt.stopPropagation(); // Prevent click event from bubbling to window
      // Submit event triggers `this.handleConfirm`, we don't need to invoke it manually.
    };

    _this.handleReject = function () {
      _this.props.onReject(false);
    };

    _this.handleRejectClick = function (evt) {
      evt.stopPropagation();

      _this.handleReject();
    };

    _this.handleSubmit = function (evt) {
      evt.preventDefault();

      if (canSubmit(_this.props.confirmButtonProps, _this.props.disableConfirm, _this.props.match, _this.state.isMatched)) {
        _this.handleConfirm();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UIConfirmDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ConfirmButton = _this$props.ConfirmButton,
          confirmButtonProps = _this$props.confirmButtonProps,
          confirmLabel = _this$props.confirmLabel,
          confirmUse = _this$props.confirmUse,
          defaultAction = _this$props.defaultAction,
          description = _this$props.description,
          disableConfirm = _this$props.disableConfirm,
          match = _this$props.match,
          matcherLabel = _this$props.matcherLabel,
          message = _this$props.message,
          __onConfirm = _this$props.onConfirm,
          __onReject = _this$props.onReject,
          RejectButton = _this$props.RejectButton,
          rejectButtonProps = _this$props.rejectButtonProps,
          rejectLabel = _this$props.rejectLabel,
          rejectUse = _this$props.rejectUse,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["ConfirmButton", "confirmButtonProps", "confirmLabel", "confirmUse", "defaultAction", "description", "disableConfirm", "match", "matcherLabel", "message", "onConfirm", "onReject", "RejectButton", "rejectButtonProps", "rejectLabel", "rejectUse", "use"]);
      var isMatched = this.state.isMatched;
      return _react.default.createElement(_UIModalDialog.default, Object.assign({}, rest, {
        use: use,
        onEsc: this.handleReject
      }), _react.default.createElement(_UIForm.default, {
        onSubmit: this.handleSubmit
      }, message && use !== 'default' ? _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, message)) : null, _react.default.createElement(_UIDialogBody.default, null, use === 'default' ? _react.default.createElement(_H2.default, null, message) : null, typeof description === 'string' ? _react.default.createElement("p", null, description) : description, match ? _react.default.createElement("div", {
        className: "private-modal__matcher-outer"
      }, _react.default.createElement(_UIFormControl.default, {
        label: matcherLabel
      }, _react.default.createElement(_UIMatchTextArea.default, {
        match: match,
        onMatchedChange: this.handleMatchedChange,
        size: "xxl"
      }))) : null), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(ConfirmButton, Object.assign({
        type: "submit",
        autoFocus: defaultAction === CONFIRM && !match,
        "data-confirm-button": "accept",
        disabled: !canSubmit(confirmButtonProps, disableConfirm, match, isMatched),
        use: confirmUse,
        onClick: this.handleConfirmClick
      }, confirmButtonProps), (0, _lazyEval.default)(confirmLabel)), _react.default.createElement(RejectButton, Object.assign({
        autoFocus: defaultAction === REJECT && !match,
        "data-confirm-button": "reject",
        onClick: this.handleRejectClick,
        use: rejectUse
      }, rejectButtonProps), (0, _lazyEval.default)(rejectLabel)))));
    }
  }]);
  return UIConfirmDialog;
}(_react.PureComponent);

UIConfirmDialog.propTypes = Object.assign({}, (0, _omit.default)(_UIModalDialog.default.propTypes, 'onEsc'), {
  ConfirmButton: _propTypes.default.elementType,
  confirmButtonProps: _propTypes.default.object,
  confirmLabel: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  confirmUse: _UIButton.default.propTypes.use,
  defaultAction: _propTypes.default.oneOf([CONFIRM, REJECT]),
  description: _propTypes.default.node,
  disableConfirm: _propTypes.default.bool,
  match: _propTypes.default.string,
  matcherLabel: _propTypes.default.node,
  message: _propTypes.default.node.isRequired,
  onConfirm: _PromptablePropInterface.default.onConfirm,
  onReject: _PromptablePropInterface.default.onReject,
  RejectButton: _propTypes.default.elementType,
  rejectButtonProps: _propTypes.default.object,
  rejectLabel: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  rejectUse: _UIButton.default.propTypes.use
});
UIConfirmDialog.defaultProps = Object.assign({}, _UIModalDialog.default.defaultProps, {
  ConfirmButton: _UIButton.default,
  confirmLabel: function confirmLabel() {
    return _I18n.default.text('salesUI.UIConfirm.defaultConfirm');
  },
  confirmUse: 'primary',
  defaultAction: REJECT,
  RejectButton: _UIButton.default,
  rejectLabel: function rejectLabel() {
    return _I18n.default.text('salesUI.UIConfirm.defaultReject');
  },
  rejectUse: 'tertiary-light',
  role: 'alertdialog'
});
UIConfirmDialog.displayName = 'UIConfirmDialog';
var _default = UIConfirmDialog;
exports.default = _default;
module.exports = exports.default;